import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1.5 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">更新快讯</h2>
          <span className="text-xs text-foreground-400 bg-background-100 px-2.5 py-1 rounded-full">实时追踪</span>
        </div>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {updates.map((item, i) => (
            <div key={i} className={`relative pb-7 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[calc(2rem+5px)] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 top-1"></div>
              <div className="flex flex-wrap items-start gap-2">
                <span className="text-xs font-medium text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.date}
                </span>
                <span className={`text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${
                  item.tag === '热血' ? 'bg-accent-100 text-accent-700' :
                  item.tag === '恋爱' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '动作' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              </div>
              <p className="mt-2 text-sm md:text-base text-foreground-800 font-medium">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}